import PromoUnavailableModal from './PromoUnavailableModal';

export default PromoUnavailableModal;
